import Axios from 'axios';

export const axiosInstance = Axios.create({
  withCredentials: true,
  baseURL: window.envUrls.BASEURL,
});
